var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[(
      _vm.couponInfos.couponType * 1 === 1 &&
      _vm.couponInfos.currency &&
      _vm.couponInfos.couponDisplayDiscount
    )?[_c('i18n',{attrs:{"path":"ranking.amount_coupon","tag":"span"}},[_c('span',{staticClass:"currency",attrs:{"place":"currency"}},[_vm._v(_vm._s(_vm.couponInfos.currency))]),_vm._v(" "),_c('span',{staticClass:"money",attrs:{"place":"money"}},[_vm._v(_vm._s(_vm.couponInfos.couponDisplayDiscount))])])]:_vm._e(),_vm._v(" "),(
      _vm.couponInfos.couponType * 1 === 2 && _vm.couponInfos.couponDisplayDiscount
    )?[_c('i18n',{attrs:{"path":"ranking.discount_coupon","tag":"span"}},[_c('span',{staticClass:"number",attrs:{"place":"number"}},[_vm._v(_vm._s(_vm.couponInfos.couponDisplayDiscount))])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }